const state = () => ({
  open_ticket:false,
  open_tickets_count:0,
  responded_tickets:false,
  displaying_ticket:null,
  admin_open_tickets:false,
  admin_open_tickets_count:0,
});
const getters = {
  open_ticket(state){
    return state.open_ticket
  },
  open_tickets_count(state){
    return state.open_tickets_count
  },
  responded_tickets(state){
    return state.responded_tickets
  },
  displaying_ticket(state){
    return state.displaying_ticket
  },
  admin_open_tickets(state){
    return state.admin_open_tickets
  },
  admin_open_tickets_count(state){
    return state.admin_open_tickets_count
  },
};
const  mutations =  {
  SET_OPEN_TICKET(state,data){
    state.open_ticket = data
  },
  SET_OPEN_TICKETS_COUNT(state,data){
    state.open_tickets_count = data
  },
  SET_RESPONDED_TICKETS(state,data){
    state.responded_tickets = data
  },
  SET_DISPLAYING_TICKET(state,data){
    state.displaying_ticket = data
  },
  SET_ADMIN_OPEN_TICKETS(state,data){
    state.admin_open_tickets = data
  },
  SET_ADMIN_OPEN_TICKETS_COUNT(state,data){
    state.admin_open_tickets_count = data
  },
};
const actions =  {
  setOpenTicket({commit},data)  {
    commit("SET_OPEN_TICKET",data)
  },
  setOpenTicketsCount({commit},data)  {
    commit("SET_OPEN_TICKETS_COUNT",data)
  },
  setRespondedTickets({commit},data)  {
    commit("SET_RESPONDED_TICKETS",data)
  },
  setDisplayingTicket({commit},data)  {
    commit("SET_DISPLAYING_TICKET",data)
  },
  setAdminOpenTickets({commit},data)  {
    commit("SET_ADMIN_OPEN_TICKETS",data)
  },
  setAdminOpenTicketsCount({commit},data)  {
    commit("SET_ADMIN_OPEN_TICKETS_COUNT",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

